module.exports = __webpack_public_path__ + "static/assets/e764d9d9a7a12892e0845b11cd4202df.png";